import React from 'react';
import { Badge } from 'react-bootstrap';

interface StatusBadgeProps {
  status: string;
  type?: 'quote' | 'invoice' | 'delivery';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type = 'quote' }) => {
  const getStatusConfig = () => {
    switch (type) {
      case 'quote':
        const quoteStatusMap = {
          draft: { bg: 'secondary', text: 'Brouillon' },
          sent: { bg: 'primary', text: 'Envoyé' },
          accepted: { bg: 'success', text: 'Accepté' },
          rejected: { bg: 'danger', text: 'Refusé' },
          converted: { bg: 'info', text: 'Converti' },
        };
        return quoteStatusMap[status as keyof typeof quoteStatusMap] || { bg: 'secondary', text: status };
      
      case 'invoice':
        const invoiceStatusMap = {
          draft: { bg: 'secondary', text: 'Brouillon' },
          sent: { bg: 'primary', text: 'Envoyée' },
          paid: { bg: 'success', text: 'Payée' },
          partially_paid: { bg: 'warning', text: 'Partiellement payée' },
          overdue: { bg: 'danger', text: 'En retard' },
          cancelled: { bg: 'dark', text: 'Annulée' },
        };
        return invoiceStatusMap[status as keyof typeof invoiceStatusMap] || { bg: 'secondary', text: status };
      
      case 'delivery':
        const deliveryStatusMap = {
          draft: { bg: 'secondary', text: 'Brouillon' },
          sent: { bg: 'primary', text: 'Envoyé' },
          delivered: { bg: 'success', text: 'Livré' },
          cancelled: { bg: 'danger', text: 'Annulé' },
        };
        return deliveryStatusMap[status as keyof typeof deliveryStatusMap] || { bg: 'secondary', text: status };
      
      default:
        return { bg: 'secondary', text: status };
    }
  };

  const config = getStatusConfig();
  
  return <Badge bg={config.bg}>{config.text}</Badge>;
};

export default StatusBadge;